export enum TrackNetTypeEnum {
    TRACKNETTYPE_UNKNOWN = 'TRACKNETTYPE_UNKNOWN',
    TRACKNETTYPE_RAIL_CONVENTIONAL = 'TRACKNETTYPE_RAIL_CONVENTIONAL',
    TRACKNETTYPE_RAIL_HIGHSPEED = 'TRACKNETTYPE_RAIL_HIGHSPEED',
    TRACKNETTYPE_RAIL_METRO = 'TRACKNETTYPE_RAIL_METRO',
    TRACKNETTYPE_RAIL_TRAM = 'TRACKNETTYPE_RAIL_TRAM',
    TRACKNETTYPE_RAIL_CABLECAR = 'TRACKNETTYPE_RAIL_CABLECAR',
}